import { AsyncResource } from './AsyncResource'

export class FileManager {
  constructor(asyncResourceManager) {
    this.arm = asyncResourceManager
    this.files = new Map()
  }

  isLoading(fileId) {
    return this.files.has(fileId)
  }

  waiting(fileId) {
    const file = new AsyncResource(fileId)
    this.files.set(fileId, file)
    this.arm.register(file)
  }

  ready(fileId) {
    const file = this.files.get(fileId)
    if (!file) return

    file.ready()
    this.files.delete(fileId)
    this.arm.unregister(fileId)
  }

  destroy() {
    this.files = new Map()
  }
}
